import React, { useState } from "react";
import cv from "./assets/cv.pdf";
// libraries
import { Route, Switch } from "react-router-dom";
// import AOS from "aos";
// import "aos/dist/aos.css";
// components
import Header from "./components/Header/Header";
import SecondaryMenu from "./components/Menu/SecondaryMenu";
// pages
import HomePage from "./pages/HomePage";
import PortfolioList from "./pages/PortfoliosList/PortfolioList";
import PortfolioDetail from "./pages/PortfolioDetail/PortfolioDetail";
// import BlogList from "./pages/BlogList/BlogList";
// import BlogDetail from "./pages/BlogDetail/BlogDetail";
import Error from "./pages/Error";

// AOS.init();

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <React.Fragment>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} cv={cv} />
      <SecondaryMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Switch>
        <Route exact path="/" component={HomePage}></Route>
        <Route exact path="/portfolios" component={PortfolioList}></Route>
        <Route path="/portfolios/:id" component={PortfolioDetail}></Route>
        {/* <Route exact path="/blogs" component={BlogList}></Route> */}
        {/* <Route path="/blogs/:id" component={BlogDetail}></Route> */}
        <Route component={Error}></Route>
      </Switch>
    </React.Fragment>
  );
}

export default App;
